// <head> metadata for JobsPage (https://www.dbos.dev/jobs).
// Kept apart from the page component so the router can load each page's code on its own.

import type { PageHead } from '@lib/head';

export const head: PageHead = {
  meta: [
    {
      title: 'Careers at DBOS | Explore Available Positions',
    },
    {
      name: 'description',
      content:
        'Careers at DBOS: join the team helping developers and companies build reliable software effortlessly, and browse our open positions.',
    },
    {
      property: 'og:title',
      content: 'Careers at DBOS | Explore Available Positions',
    },
    {
      property: 'og:description',
      content:
        'Careers at DBOS: join the team helping developers and companies build reliable software effortlessly, and browse our open positions.',
    },
    {
      property: 'og:image',
      content: 'https://www.dbos.dev/assets/images/dbos-og-durable-workflows-postgres.jpg',
    },
    {
      name: 'twitter:title',
      content: 'Careers at DBOS | Explore Available Positions',
    },
    {
      name: 'twitter:description',
      content:
        'Careers at DBOS: join the team helping developers and companies build reliable software effortlessly, and browse our open positions.',
    },
    {
      name: 'twitter:image',
      content: 'https://www.dbos.dev/assets/images/dbos-og-durable-workflows-postgres.jpg',
    },
    {
      property: 'og:type',
      content: 'website',
    },
    {
      name: 'twitter:card',
      content: 'summary_large_image',
    },
  ],
  links: [
    {
      href: 'https://www.dbos.dev/jobs',
      rel: 'canonical',
    },
  ],
  scripts: [],
};
